import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Grid } from 'src/ui/common/atoms/grid';
import { SvgIcon } from 'src/ui/common/atoms/svg-icon';
import { Typography } from 'src/ui/common/atoms/typography';
import { Modal } from 'src/ui/common/layouts/modal';
import { Button } from 'src/ui/white-labels/techcontemporary/atoms/button';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
    & > div {
        border: none;
    }
`;

export const StyledLoginModalWrapper = styled(FlexBox)`
    max-width: 448px;
    margin: 0 auto;
`;

export const StyledAuthFormContainer = styled(FlexBox)`
    height: 100%;

    input {
        width: 100%;
    }

    & > button {
        margin: 12px 0 30px;
    }

    button + span {
        display: block;
        margin: 0 0 10px;
    }

    a {
        color: ${({ theme }) => theme.colors.pink500};
    }

    & > p {
        color: ${({ theme }) => theme.colors.gs200};
        margin: 0 0 40px;
    }
`;

export const StyledAuthFieldsContainer = styled(FlexBox)`
    gap: 18px;
`;

export const StyledEmailIconWrapper = styled(FlexBox)``;

export const StyledIconContainer = styled.div`
    padding: 15px 17px;
    background: ${({ theme }) => theme.colors.black};
    border-radius: 50%;
    display: inline-block;
    margin-bottom: 24px;
`;

export const StyledAuthFormTitle = styled.div`
    margin: 0 auto;
    text-align: center;

    & > h2 {
        margin-bottom: 12px;
        font-size: 28px;
        line-height: 36px;
    }

    & svg {
        width: 31px;
        height: 31px;
    }
`;

export const StyledPasswordRequirements = styled(Grid)`
    margin: 22px 0;
`;

export const StyledAuthTrigger = styled.span`
    text-decoration: underline;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.gs100};
`;

export const StyledFormError = styled(Typography)`
    margin: 22px 0 10px;
`;

export const StyledValidationIcon = styled(SvgIcon)`
    align-self: flex-start;
`;

export const StyledInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-bottom: 18px;
`;

export const StyledLabelstWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;
export const StyledCheckBoxItem = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`;

export const StyledHeaderWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 5px;
`;

export const StyledFlexBox = styled(FlexBox)`
    padding: 28px;
    height: 100%;

    & form {
        height: 100%;
    }
`;

export const StyledButton = styled(Button)`
    margin: 24px 0 20px !important;
`;

export const StyledIconWrapper = styled.div`
    width: 80px;
    height: 80px;
    background: ${({ theme }) => theme.colors.lightGreen};
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyledTypography = styled(Typography)`
    text-align: start;
`;

export const StyledPasswordInput = styled.div`
    & > div {
        position: relative;
    }

    input {
        margin: 0;
        padding-right: 48px;
    }

    button {
        cursor: pointer;
        user-select: none;
        display: grid;
        place-items: center;
        margin: 0;
        appearance: none;
        border: none;
        background: none;
        position: absolute;
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
    }
`;